import React, { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { Note } from '../../../models/Note'
import { L, L_HTML } from '../../providers/Lokalise'
import { Button } from '../../ui/Button/Button'
import { Typography } from '../../ui/Typography/Typography'
import { EditMemberNoteButton } from './EditMemberNoteButton'
import { NoteSidebarCard } from './NoteSidebarCard'
import { colors } from '../../../theme/palette'

interface NoteOverviewSidebarProps {
    notes: Note[]
    onClickEdit: (note: Note) => void
    onClickDelete: (note: Note) => void
    onClickCreate: () => void
}

const useStyles = createUseStyles({
    contentWrapper: {
        padding: '100px 20px 20px',
        overflow: 'auto',
        height: '100%',
        paddingBottom: '80px',
    },
    createNote: {
        marginBottom: '20px',
    },
})

const NoteOverviewSidebar: FC<NoteOverviewSidebarProps> = ({
    notes,
    onClickEdit,
    onClickDelete,
    onClickCreate,
}) => {
    const classes = useStyles()

    return (
        <div className={classes.contentWrapper}>
            <Typography
                tag="h2"
                size="L"
                align="center"
                weight="bold"
                style={{ margin: '20px 0' }}
            >
                {L_HTML('NOTER_SIDEBAR_OVERSIGT_TITEL')}
            </Typography>
            <div className={classes.createNote}>
                <EditMemberNoteButton
                    notes={[]}
                    onClickCreate={onClickCreate}
                    withBorder
                    firstNoteLabel="Opret note"
                />
            </div>
            {notes
                .sort(
                    (a: Note, b: Note) =>
                        b.updated.getTime() - a.updated.getTime()
                )
                .map((note) => {
                    return (
                        <NoteSidebarCard
                            key={note.id}
                            note={note}
                            onClickEdit={onClickEdit}
                            onClickDelete={onClickDelete}
                        />
                    )
                })}
        </div>
    )
}

export { NoteOverviewSidebar }
